<template>
    <div class="MResumePreview" v-if="isshow">
        <MHeader ref="mtalentheader"></MHeader>
        <div class="my_resume_warp">
            <!--个人信息-->
            <div class="resume_baseinfo_box">
                <div v-if="resumeData.baseinfo.name === ''" class="left_div">
                    <p class="p1">未填写</p>
                    <p class="p2">工作经验<span>·</span>学历<span>·</span>任职</p>
                </div>
                <div v-else class="left_div">
                    <p class="p1">{{resumeData.baseinfo.name}}</p>
                    <p class="p2">{{resumeData.baseinfo.exptype}}<span>·</span>{{resumeData.baseinfo.edutype}}<span>·</span>{{resumeData.baseinfo.jobstatus}}</p>
                </div>
                <img class="user_head_img" :src="resumeData.baseinfo.customericonurl?resumeData.baseinfo.customericonurl:require('@/common/images/mtalentimgs/head_img.png')" alt="">
            </div>
            <!--基本信息-->
            <div class="resume_item_box">
                <div class="title_div">
                    <p class="p_title_text">基本信息</p>
                </div>
                <div class="personInfo top20">
                    <p><span>性别</span><span>{{resumeData.baseinfo.sex}}</span></p>
                    <p><span>年龄</span><span>{{resumeData.baseinfo.age}}</span></p>
                    <p><span>城市</span><span>{{resumeData.baseinfo.nativeplace}}{{resumeData.baseinfo.domplace}}</span></p>
                    <p><span>目前年薪</span>{{resumeData.baseinfo.currentsalary+'万/年'}}<span></span></p>
                </div>
            </div>
            <!--求职意向-->
            <div class="resume_item_box">
                <div class="title_div">
                    <p class="p_title_text">求职意向</p>
                </div>
                <div v-if="resumeData.baseinfo.wishjobname !== ''" class="Job_Intension_box top20">
                    <div>
                        <span>{{resumeData.baseinfo.wishjobname}}</span>
                        <span v-if="resumeData.baseinfo.wishsalary === 0 && resumeData.baseinfo.wishsalarymax === 0 && resumeData.baseinfo.wishindustry !== ''">面议</span>
                        <span v-if="resumeData.baseinfo.wishsalary !== 0 && resumeData.baseinfo.wishsalarymax !== 0">{{resumeData.baseinfo.wishsalary}}-{{resumeData.baseinfo.wishsalarymax}}万/年</span>
                        <span v-if="resumeData.baseinfo.wishindustry === ''"></span>
                    </div>
                    <div>
                        <span>{{resumeData.baseinfo.wishplace}}</span>
                        <span>{{resumeData.baseinfo.wishindustry}}</span>
                    </div>
                </div>
            </div>
            <!--工作经历-->
            <div class="resume_item_box">
                <div class="title_div">
                    <p class="p_title_text">工作经历</p>
                </div>
                <div v-if="resumeData.companyinfolist.length > 0" class="Work_History_box top20">
                    <div class="list_item_box" v-for="(item, index) in resumeData.companyinfolist" :key="index">
                        <div class="firm_div">
                            <div class="firm_name van-ellipsis">{{item.companyname}}</div>
                            <div class="time_div">
                                <span>{{item.jobbegin}}-{{item.istoday ? '至今' : item.jobend}}</span>
                            </div>
                        </div>
                        <div class="common2_text">{{item.jobname}}</div>
                        <div v-if="item.jobinfo !== ''" class="Performance_text common_text van-multi-ellipsis--l2">{{item.jobinfo}}</div>
                    </div>
                </div>
                <div class="list_noData" v-else>未填写</div>
            </div>
            <!--项目经历-->
            <div class="resume_item_box">
                <div class="title_div">
                    <p class="p_title_text">项目经历</p>
                </div>
                <div v-if="resumeData.projectinfolist.length > 0" class="Project_Experience_box top20">
                    <div class="list_item_box" v-for="(item, index) in resumeData.projectinfolist" :key="index">
                        <div class="firm_div">
                            <div class="firm_name van-ellipsis">{{item.projectname}}</div>
                            <div class="time_div">
                                <span>{{item.projectbegin}}-{{item.istoday ? '至今' : item.projectend}}</span>
                            </div>
                        </div>
                        <div class="position_title common2_text">{{item.dutyname}}</div>
                        <div class="common_text van-multi-ellipsis--l2">职责：{{item.projectduty}}</div>
                        <div v-if="item.projectexpinfo !== ''" class="common_text van-multi-ellipsis--l2">业绩：{{item.projectexpinfo}}</div>
                        <div class="common_text van-multi-ellipsis--l2">描述：{{item.projectinfo}}</div>
                    </div>
                </div>
                <div class="list_noData" v-else>未填写</div>
            </div>
            <!--教育经历-->
            <div class="resume_item_box">
                <div class="title_div">
                    <p class="p_title_text">教育经历</p>
                </div>
                <div v-if="resumeData.eduinfolist.length > 0" class="Edu_Experience_box top20">
                    <div class="list_item_box" v-for="(item, index) in resumeData.eduinfolist" :key="index">
                        <div class="firm_div">
                            <div class="firm_name van-ellipsis">{{item.eduname}}</div>
                            <div class="time_div">
                                <span>{{item.edubegin}}-{{item.istoday ? '至今' : item.eduend}}</span>
                            </div>
                        </div>
                        <div class="edu_info_div">
                            <div class="common2_text">{{item.edulevel}}</div>
                            <div class="common2_text">{{item.majorname}}</div>
                        </div>
                    </div>
                </div>
                <div class="list_noData" v-else>未填写</div>
            </div>
            <!--自我评价-->
            <div class="resume_item_box">
                <div class="title_div">
                    <p class="p_title_text">自我评价</p>
                </div>
                <div v-if="resumeData.baseinfo.selfevaluation !== ''" class="Self_Evaluation_box top20 van-multi-ellipsis--l3 common_text">{{resumeData.baseinfo.selfevaluation}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import MHeader from 'views/mtalent/components/mheader/mHeader'
    import {getResumeDetail} from 'api/talentApi'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'MResumePreview',
        data() {
            return {
                isshow:false,
                resumeData: {
                    baseinfo: {}, // 基本信息
                    companyinfolist:[], // 工作经历
                    projectinfolist: [], // 项目经历
                    eduinfolist: [] // 教育经历
                },
            }
        },
        created() {
            if(!this.domainInfo.isMobile){
                this.$router.push({
                    name: 'ResumePreview',
                    query: {'innerid': this.$route.query.innerid}
                })
            }
        },
        mounted() {
            this.findResumeAllInfo()
        },
        activated() {},
        methods: {
            findResumeAllInfo() {
                this.setLoading(true)
                let params = {
                    innerid:this.$route.query.innerid?this.$route.query.innerid:''
                }
                getResumeDetail({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.isshow = true
                        this.resumeData = data.data
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$toast.fail(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters(['domainInfo'])
        },
        components: {
            MHeader
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .MResumePreview {
        font-family:PingFangSC-Medium,PingFang SC;
        .van-tabs__nav--line {
            padding-bottom: 0.16rem;
        }
        .content_warp {
            min-height: calc(100vh - 1.08rem);
            margin-top: 0.2rem;
        }
        .top_tips {
            padding: 0 0.32rem;
            background-color: #FEFCEB;
            line-height: 0.72rem;
            font-size: 0.24rem;
            color: #F96A0E;
            display: flex;
            justify-content: space-between;
            &>p:nth-of-type(2) {
                color: #409EFF;
            }
        }
        .my_resume_warp {
            min-height: calc(100vh - 1.6rem);
            background-color: #FFF;
            padding: 0 0.32rem;
            color: #333;
            margin-top: 0.88rem;
            .resume_baseinfo_box {
                border-bottom: 0.01rem solid #E5E5E5;
                padding: 0.4rem 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left_div {
                    .p1 {
                        display: flex;
                        align-items: center;
                        color: #000;
                        font-weight: bold;
                        font-size: 0.52rem;
                        line-height: 0.74rem;
                        margin-bottom: 0.1rem;
                        &>img {
                            width: 0.32rem;
                            height: 0.32rem;
                            margin-left: 0.3rem;
                        }
                    }
                    .p2 {
                        line-height: 0.34rem;
                        font-size: 0.24rem;
                        color: #666;
                        &>span {
                            margin: 0 0.2rem;
                        }
                    }
                }
                .user_head_img {
                    width: 1.2rem;
                    height: 1.2rem;
                    border-radius: 0.6rem;
                }
            }
            .resume_item_box {
                border-bottom: 0.01rem solid #E5E5E5;
                padding: 0.4rem 0;
                .title_div {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .p_title_text {
                        font-weight: bold;
                        font-size: 0.32rem;
                        line-height: 0.46rem;
                    }
                    .handle_img_div {
                        .handle_img {
                            width: 0.32rem;
                            height: 0.32rem;
                        }
                    }
                }
                .personInfo{
                    p{
                        font-size: 0.28rem;
                        line-height: 0.4rem;
                        color: #666;
                        margin-top: 0.2rem;
                        span:first-child{
                            width: 1.6rem;
                            display: inline-block;
                        }
                    }
                }
                .list_noData{
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                    color: #666;
                    margin-top: 0.4rem;
                }
                .top20 {
                    margin-top: 0.4rem;
                }
                .Job_Intension_box {
                    &>div {
                        span {
                            font-size: 0.28rem;
                            line-height: 0.4rem;
                            color: #999;
                        }
                        span + span {
                            margin-left: 0.2rem;
                        }
                    }
                    &>div:nth-of-type(1) {
                        span {
                            font-weight: bold;
                            color: #333;
                        }
                    }
                    div + div {
                        margin-top: 0.1rem;
                    }
                }
                .Work_History_box {
                    .Performance_text {
                        margin-top: 0.24rem;
                    }
                }
                .Project_Experience_box {
                    .position_title {
                        margin-bottom: 0.24rem;
                    }
                }
                .Edu_Experience_box {
                    .edu_info_div {
                        display: flex;
                        .common2_text + .common2_text {
                            margin-left: 0.2rem;
                        }
                    }
                }
                .Self_Evaluation_box {
                    color: #666;
                }
                .list_item_box {
                    .firm_div {
                        display: flex;
                        justify-content: space-between;
                        .firm_name {
                            width: 3.92rem;
                            line-height: 0.4rem;
                            font-size: 0.28rem;
                            font-weight: bold;
                            color: #333;
                        }
                        .time_div {
                            display: flex;
                            align-items: center;
                            span {
                                line-height: 0.4rem;
                                font-size: 0.28rem;
                                color: #999;
                            }
                            img {
                                width: 0.15rem;
                                height: 0.25rem;
                                margin-left: 0.2rem;
                            }
                        }
                    }
                }
                .list_item_box + .list_item_box {
                    margin-top: 0.4rem;
                }
                .common_text {
                    color: #666;
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                    text-align: justify;
                }
                .common_text + .common_text {
                    margin-top: 0.1rem;
                }
                .common2_text {
                    color: #999;
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                    margin-top: 0.1rem;
                }
            }
        }
        .apply_record_warp {
            .van-pull-refresh {
                min-height: 70vh;
            }
            .van-list__finished-text {
                font-size: 0.24rem;
            }
            .post_item_box {
                background-color: #fff;
                padding: 0.32rem;
                margin-top: 0.2rem;
                .job_info_box {
                    height: 0.44rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .p1 {
                        width: 4.86rem;
                        font-weight: bold;
                        font-size:0.32rem;
                        width: 4rem;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    .p2 {
                        font-size: 0.28rem;
                    }
                    .green_text {
                        color: #67C23A;
                    }
                    .yellow_text {
                        color: #FF7F04;
                    }
                    .red_text {
                        color: #F56C6C;
                    }
                }
                .salary_text {
                    color: #FF7F04;
                    font-size: 0.32rem;
                    margin: 0.08rem 0;
                    line-height: 0.46rem;
                    font-weight: bold;
                }
                .p_name_text {
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    margin-bottom: 0.2rem;
                    color: #999999;
                }
                .tags_box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .tags_div {
                        display: flex;
                        &>p {
                            color: #5EBDFF;
                            border-radius: 0.04rem;
                            padding: 0 0.1rem;
                            height: 0.4rem;
                            line-height: 0.4rem;
                            text-align: center;
                            font-size: 0.24rem;
                            border: 0.02rem solid #5EBDFF;
                            max-width: 1.3rem;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                        }
                        p + p {
                            margin-left: 0.2rem;
                        }
                    }
                    .time_text {
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                        color: #999999;
                    }
                }
            }
        }
        .noData{
            height: calc(100vh - 1.08rem);
            background: #FFF;
        }
    }
</style>